import React, { useEffect, useRef, useState } from 'react'
import axios from '../../API/axios';
import { recordSearch } from '../../API/searchHistory';
import JobList from './JobList';
import SearchHeader from './SearchHeader';
import JobFilter from './JobFilter';
import { header } from "../../config/imagesLink";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GoogleAdUnit from '../../components/GoogleAdUnit';
import TuneSharpIcon from '@mui/icons-material/TuneSharp';
import "./JobSearchRedesign.css";
import "../../styles/recruiterFeatures.css";

const JobSearch = () => {

    const scrollContainerRef = useRef();
    const workspaceRef = useRef(null);
    const stickyChromeRef = useRef(null);
    const listGenerationRef = useRef(0);
    const isFetchingMoreRef = useRef(false);
    const pageRef = useRef(1);
    const totalPagesRef = useRef(1);
    const skipNextFilterEffectRef = useRef(false);
    const filtersSnapshotRef = useRef(null);
    const filterMastersRef = useRef({
        country: [],
        city: [],
        company: [],
        designation: [],
    });
    const filtersInitializedRef = useRef(false);
    // Track which parent filters last drove City / Company / Designation option lists
    const lastListScopeRef = useRef({
        countryKey: null,
        cityKey: null,
        companyKey: null,
    });

    const getFiltersSnapshot = () =>
        JSON.stringify({
            debouncedSearch,
            selectedCountryData,
            selectedCity,
            selectedCompanyData,
            selectedDesignationData,
            selectedJobTypeData,
            selectedSalaryType,
            selectedWorkLocation,
            selectedWorkLevel,
            completenessFilter,
        });

    // Never shrink option lists when merging — keeps unchecked items visible
    const mergeFilterOptions = (prev = [], next = []) => {
        if (!prev?.length) return next || [];
        if (!next?.length) return prev;
        const nextById = new Map(next.map((item) => [item.id, item]));
        const prevIds = new Set(prev.map((item) => item.id));
        const merged = prev.map((item) => nextById.get(item.id) || item);
        next.forEach((item) => {
            if (!prevIds.has(item.id)) {
                merged.push(item);
            }
        });
        return merged;
    };

    const scopeKey = (ids = []) => JSON.stringify([...(ids || [])].map(String).sort());

    // Empty or "all checked" ⇒ no filter for that dimension (API returns full dependent lists).
    const toFilterIds = (selected = [], options = []) => {
        if (!options?.length) return [];
        if (!selected?.length) return [];
        if (selected.length >= options.length) return [];
        return selected;
    };

    // When parent filter changes, keep valid child picks or default to all of the new list.
    const syncSelectionToOptions = (prevSelected = [], prevOptions = [], nextOptions = []) => {
        const nextIds = (nextOptions || []).map((item) => item.id);
        if (!nextIds.length) return [];
        const prevLen = prevOptions?.length || 0;
        const wasAll =
            !prevSelected?.length ||
            (prevLen > 0 && prevSelected.length >= prevLen);
        if (wasAll) return nextIds;
        const kept = prevSelected.filter((id) => nextIds.includes(id));
        return kept.length ? kept : nextIds;
    };

    const arraysEqualAsSets = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        const setB = new Set(b);
        return a.every((id) => setB.has(id));
    };

    const { t } = useTranslation();
    const sessionId = localStorage.getItem("sessionId");
    const guestModeData = localStorage.getItem("guestMode");
    const userUid = localStorage.getItem("userUid");
    const [filterJobList, setFilterJobList] = useState([]);
    const [country, setCountry] = useState([]);
    const [selectedCountryData, setSelectedCountryData] = useState([]);
    const [city, setCity] = useState([]);
    const [selectedCity, setSelectedCity] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyData, setSelectedCompanyData] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [selectedDesignationData, setSelectedDesignationData] = useState([]);
    const [selectedJobTypeData, setSelectedJobTypeData] = useState([]);
    const [jobTypeList, setJobTypeList] = useState([]);
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [selectedSalaryType, setSelectedSalaryType] = useState([]);
    const [selectedWorkLevel, setSelectedWorkLevel] = useState([]);
    const [workLevelTypeList, setWorkLevelTypeList] = useState([]);
    const [workLocationType, setWorkLocationTypeList] = useState([]);
    const [selectedWorkLocation, setSelectedWorkLocationList] = useState([]);
    const ProfilePercent = localStorage.getItem("ProfilePercentage"); 

    //************************ jobs list Start  ************************//
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [jobsList, setJobsList] = useState([]);
    const [searchjobsList, setSearchJobsList] = useState([]);
    const [isError, setIsError] = useState(false);
    const [reset, setReset] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [hasMoreData, setHasMoreData] = useState(true);
    const [nextBatchLoading, setNextBatchLoading] = useState(false);
    const [debouncedSearch, setDebouncedSearch] = useState(searchValue);
    const [completenessFilter, setCompletenessFilter] = useState("all");
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    useEffect(() => {
        totalPagesRef.current = totalPages;
    }, [totalPages]);

    useEffect(() => {
        if (!nextBatchLoading && !isLoading) {
            isFetchingMoreRef.current = false;
        }
    }, [nextBatchLoading, isLoading]);

    useEffect(() => {
        const chrome = stickyChromeRef.current;
        const workspace = workspaceRef.current;
        if (!chrome || !workspace) {
            return undefined;
        }

        const updateStickyOffset = () => {
            const height = Math.round(chrome.getBoundingClientRect().height);
            workspace.style.setProperty("--wlj-screen-sticky-filter-offset", `${height}px`);
        };

        updateStickyOffset();
        const observer = new ResizeObserver(updateStickyOffset);
        observer.observe(chrome);
        window.addEventListener("resize", updateStickyOffset);
        return () => {
            observer.disconnect();
            window.removeEventListener("resize", updateStickyOffset);
        };
    }, [mobileFiltersOpen]);

    const getAllJobList = (page, options = {}) => {
        const { replaceList = false } = options;
        const isFirstPage = page === 1;
        const requestGeneration = listGenerationRef.current;

        if (isFirstPage) {
            setIsLoading(true);
            setNextBatchLoading(false);
            if (replaceList) {
                setJobsList([]);
                setIsError(false);
            }
        } else {
            setNextBatchLoading(true);
        }

        const countryIDs = toFilterIds(selectedCountryData, country);
        const cityIDs = toFilterIds(selectedCity, city);
        const companyIDs = toFilterIds(selectedCompanyData, companyList);
        const designationIDs = toFilterIds(selectedDesignationData, designationList);
        const requestCountryKey = scopeKey(countryIDs);
        const requestCityKey = scopeKey(cityIDs);
        const requestCompanyKey = scopeKey(companyIDs);

        const data = {
            search: debouncedSearch,
            // "All selected" / empty ⇒ send [] so dependents return the full relevant lists
            countryIDs,
            cityIDs,
            companyIDs,
            jobtypeIDs: selectedJobTypeData,
            workLevelTypeIDs: selectedWorkLevel,
            workLocationTypeIDs: selectedWorkLocation,
            salaryTypeIDs: selectedSalaryType,
            designationIDs,
            skillIDs: [],
            deviceType: "Web",
            pageNumber: page,
            pageSize: 12,
            completenessFilter: completenessFilter === "all" ? null : completenessFilter,
        };

        if (isFirstPage && debouncedSearch?.trim()) {
            recordSearch({ searchKey: debouncedSearch, typeId: 2 });
        }

        axios
            .post(`Job/GetJobsWithFilters`, data)
            .then((response) => {
                if (requestGeneration !== listGenerationRef.current) {
                    return;
                }

                if (response.status === 204) {
                    setIsError(true);
                    if (isFirstPage) {
                        setJobsList([]);
                    }
                } else {
                    setIsError(false);
                    const responseTotalPages = response.data.responseData.paging.totalPages;
                    setTotalPages(responseTotalPages);
                    const filters = response.data.responseData.filters || {};
                    const nextCountries = filters.countryList || [];
                    const nextCities = filters.cityList || [];
                    const nextCompanies = filters.companyList || [];
                    const nextDesignations = filters.designationList || [];

                    const prevCities = city;
                    const prevCompanies = companyList;
                    const prevDesignations = designationList;

                    // Country: always keep the full master list (unchecked countries stay visible)
                    const mergedCountries = mergeFilterOptions(country, nextCountries);
                    setCountry(mergedCountries);

                    /*
                     * Dependent dropdowns:
                     * - Replace lists only when the PARENT filter scope changes
                     *   (Country → City, City → Company, Company → Designation)
                     * - When the user only unchecks options in the same dropdown,
                     *   MERGE so unchecked items stay visible in the list
                     */
                    const countryScopeChanged =
                        lastListScopeRef.current.countryKey !== requestCountryKey;
                    const cityScopeChanged =
                        lastListScopeRef.current.cityKey !== requestCityKey;
                    const companyScopeChanged =
                        lastListScopeRef.current.companyKey !== requestCompanyKey;

                    let appliedCities = prevCities;
                    let appliedCompanies = prevCompanies;
                    let appliedDesignations = prevDesignations;

                    if (countryScopeChanged || !filtersInitializedRef.current) {
                        // New country scope → fresh city / company / designation lists
                        appliedCities = nextCities;
                        appliedCompanies = nextCompanies;
                        appliedDesignations = nextDesignations;
                        setCity(nextCities);
                        setCompanyList(nextCompanies);
                        setDesignationList(nextDesignations);
                        lastListScopeRef.current = {
                            countryKey: requestCountryKey,
                            cityKey: requestCityKey,
                            companyKey: requestCompanyKey,
                        };
                    } else if (cityScopeChanged) {
                        // City selection changed → keep full city list; refresh company / designation
                        appliedCities = mergeFilterOptions(prevCities, nextCities);
                        appliedCompanies = nextCompanies;
                        appliedDesignations = nextDesignations;
                        setCity(appliedCities);
                        setCompanyList(nextCompanies);
                        setDesignationList(nextDesignations);
                        lastListScopeRef.current.cityKey = requestCityKey;
                        lastListScopeRef.current.companyKey = requestCompanyKey;
                    } else if (companyScopeChanged) {
                        // Company selection changed → keep city + company lists; refresh designation
                        appliedCities = mergeFilterOptions(prevCities, nextCities);
                        appliedCompanies = mergeFilterOptions(prevCompanies, nextCompanies);
                        appliedDesignations = nextDesignations;
                        setCity(appliedCities);
                        setCompanyList(appliedCompanies);
                        setDesignationList(nextDesignations);
                        lastListScopeRef.current.companyKey = requestCompanyKey;
                    } else {
                        // Designation (or other) change only — never shrink any dropdown list
                        appliedCities = mergeFilterOptions(prevCities, nextCities);
                        appliedCompanies = mergeFilterOptions(prevCompanies, nextCompanies);
                        appliedDesignations = mergeFilterOptions(
                            prevDesignations,
                            nextDesignations
                        );
                        setCity(appliedCities);
                        setCompanyList(appliedCompanies);
                        setDesignationList(appliedDesignations);
                    }

                    // Sidebar filters: keep full option lists
                    setJobTypeList((prev) => mergeFilterOptions(prev, filters.jobTypeList || []));
                    setSalaryTypeList((prev) => mergeFilterOptions(prev, filters.salaryTypeList || []));
                    setWorkLevelTypeList((prev) => mergeFilterOptions(prev, filters.workLevelTypeList || []));
                    setWorkLocationTypeList((prev) => mergeFilterOptions(prev, filters.workLocationTypeList || []));

                    // Capture masters on first successful load
                    if (!filterMastersRef.current.country.length && mergedCountries.length) {
                        filterMastersRef.current = {
                            country: mergedCountries,
                            city: appliedCities,
                            company: appliedCompanies,
                            designation: appliedDesignations,
                        };
                    }

                    const nextCountryIds = mergedCountries.map((item) => item.id);
                    // Only re-sync child selections when that list was replaced by a parent change
                    const nextCityIds = countryScopeChanged || !filtersInitializedRef.current
                        ? syncSelectionToOptions(selectedCity, prevCities, appliedCities)
                        : selectedCity.filter((id) =>
                              appliedCities.some((item) => item.id === id)
                          ).length
                            ? selectedCity.filter((id) =>
                                  appliedCities.some((item) => item.id === id)
                              )
                            : selectedCity;
                    const nextCompanyIds =
                        countryScopeChanged || cityScopeChanged || !filtersInitializedRef.current
                            ? syncSelectionToOptions(
                                  selectedCompanyData,
                                  prevCompanies,
                                  appliedCompanies
                              )
                            : selectedCompanyData.filter((id) =>
                                  appliedCompanies.some((item) => item.id === id)
                              ).length
                                ? selectedCompanyData.filter((id) =>
                                      appliedCompanies.some((item) => item.id === id)
                                  )
                                : selectedCompanyData;
                    const nextDesignationIds =
                        countryScopeChanged ||
                        cityScopeChanged ||
                        companyScopeChanged ||
                        !filtersInitializedRef.current
                            ? syncSelectionToOptions(
                                  selectedDesignationData,
                                  prevDesignations,
                                  appliedDesignations
                              )
                            : selectedDesignationData.filter((id) =>
                                  appliedDesignations.some((item) => item.id === id)
                              ).length
                                ? selectedDesignationData.filter((id) =>
                                      appliedDesignations.some((item) => item.id === id)
                                  )
                                : selectedDesignationData;

                    // First load: select all options by default
                    if (!filtersInitializedRef.current && nextCountryIds.length) {
                        filtersInitializedRef.current = true;
                        skipNextFilterEffectRef.current = true;
                        const allCityIds = appliedCities.map((c) => c.id);
                        const allCompanyIds = appliedCompanies.map((c) => c.id);
                        const allDesignationIds = appliedDesignations.map((d) => d.id);
                        setSelectedCountryData(nextCountryIds);
                        setSelectedCity(allCityIds);
                        setSelectedCompanyData(allCompanyIds);
                        setSelectedDesignationData(allDesignationIds);
                        filterMastersRef.current = {
                            country: mergedCountries,
                            city: appliedCities,
                            company: appliedCompanies,
                            designation: appliedDesignations,
                        };
                        lastListScopeRef.current = {
                            countryKey: "[]",
                            cityKey: "[]",
                            companyKey: "[]",
                        };
                    } else if (countryScopeChanged || cityScopeChanged || companyScopeChanged) {
                        // Parent changed → sync children; skip refetch when API already used []
                        const cityChanged = !arraysEqualAsSets(selectedCity, nextCityIds);
                        const companyChanged = !arraysEqualAsSets(
                            selectedCompanyData,
                            nextCompanyIds
                        );
                        const designationChanged = !arraysEqualAsSets(
                            selectedDesignationData,
                            nextDesignationIds
                        );

                        if (cityChanged || companyChanged || designationChanged) {
                            const cityWasApiAll =
                                !selectedCity.length ||
                                (prevCities.length > 0 &&
                                    selectedCity.length >= prevCities.length);
                            const companyWasApiAll =
                                !selectedCompanyData.length ||
                                (prevCompanies.length > 0 &&
                                    selectedCompanyData.length >= prevCompanies.length);
                            const designationWasApiAll =
                                !selectedDesignationData.length ||
                                (prevDesignations.length > 0 &&
                                    selectedDesignationData.length >= prevDesignations.length);

                            const onlyUiSync =
                                (!cityChanged || cityWasApiAll) &&
                                (!companyChanged || companyWasApiAll) &&
                                (!designationChanged || designationWasApiAll);

                            if (onlyUiSync) {
                                skipNextFilterEffectRef.current = true;
                            }
                            if (cityChanged) setSelectedCity(nextCityIds);
                            if (companyChanged) setSelectedCompanyData(nextCompanyIds);
                            if (designationChanged) {
                                setSelectedDesignationData(nextDesignationIds);
                            }
                        }
                    }

                    const newPosts = response.data.responseData.jobs || [];

                    setJobsList((prev) => {
                        if (isFirstPage || replaceList || reset) {
                            if (reset) {
                                setReset(false);
                            }
                            return newPosts;
                        }

                        const postSet = new Set(prev.map((p) => p.jobId));
                        const uniqueNewPosts = newPosts.filter((p) => !postSet.has(p.jobId));
                        return [...prev, ...uniqueNewPosts];
                    });

                    setHasMoreData(page < responseTotalPages);
                }

                if (isFirstPage) {
                    setIsLoading(false);
                } else {
                    setNextBatchLoading(false);
                }
            })
            .catch((error) => {
                if (requestGeneration !== listGenerationRef.current) {
                    return;
                }

                if (error.response && error.response.status === 404) {
                    setIsError(true);
                    if (isFirstPage) {
                        setJobsList([]);
                    }
                } else {
                    console.log(error);
                }

                setReset(false);

                if (isFirstPage) {
                    setIsLoading(false);
                } else {
                    setNextBatchLoading(false);
                }
            });
    };
   

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchValue);
        }, 1000); // 500ms pause ke baad update hoga

        return () => clearTimeout(timer);
    }, [searchValue]);
    useEffect(() => {
        if (page > 1 && !reset && hasMoreData && page <= totalPages) {
            getAllJobList(page);
        }
    }, [page]);

    useEffect(() => {
        const currentSnapshot = getFiltersSnapshot();

        if (skipNextFilterEffectRef.current) {
            skipNextFilterEffectRef.current = false;
            filtersSnapshotRef.current = currentSnapshot;
            return;
        }

        if (filtersSnapshotRef.current === currentSnapshot) {
            return;
        }

        filtersSnapshotRef.current = currentSnapshot;
        listGenerationRef.current += 1;
        isFetchingMoreRef.current = false;
        setPage(1);
        setHasMoreData(true);
        getAllJobList(1, { replaceList: true });
    }, [
        debouncedSearch,
        selectedCountryData,
        selectedCity,
        selectedCompanyData,
        selectedDesignationData,
        selectedJobTypeData,
        selectedSalaryType,
        selectedWorkLocation,
        selectedWorkLevel,
        completenessFilter
    ]);

    const handleInfiniteScroll = () => {
        if (
            window.innerHeight + window.scrollY >= document.body.scrollHeight - 100 &&
            !nextBatchLoading &&
            !isFetchingMoreRef.current &&
            hasMoreData &&
            !isLoading &&
            !reset &&
            pageRef.current < totalPagesRef.current
        ) {
            isFetchingMoreRef.current = true;
            setPage((prev) => {
                if (prev >= totalPagesRef.current) {
                    isFetchingMoreRef.current = false;
                    return prev;
                }
                return prev + 1;
            });
        }
    };

    //************************ jobs list End  ************************//

    const [alert, setAlert] = useState(false);
    const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state

    const normalizedUserPer = Array.isArray(ProfilePercent) ? (ProfilePercent.length === 0 ? 0 : Number(ProfilePercent[0])) : Number(ProfilePercent);

    const shouldShowAlert = !isLoadingalert || normalizedUserPer <= 59 && alert === false && guestModeData === null;

    useEffect(() => {
        window.addEventListener("scroll", handleInfiniteScroll);
        return () => window.removeEventListener("scroll", handleInfiniteScroll);
    }, [nextBatchLoading, hasMoreData, isLoading, reset]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <>
            <Helmet>
                <title>Search Job | Welinkjobs </title>
                <meta name="description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta name="keywords" content="react, meta tags, seo" /> */}
                {/* <meta name="author" content="Your Name" /> */}
                <meta property="og:title" content="Find Your Next Opportunity: Welinkjobs Jobs Search" />
                <meta property="og:description" content="Unleash your job search potential with Welinkjobs. Explore opportunities on the most trusted job search sites and find your dream job." />
                {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
                <meta property="og:url" content="https://welinkjobs.com/SearchJob" />
            </Helmet>
            <div className="p-lg-5 p-md-2 p-2 mt-5 PaddingTop padding-bottom wlj-job-search-page">
                {shouldShowAlert && (
                    <div className='p-3 closeAccount m-0 mb-3 mt-1'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>{t("Newsfeed.Announcement")} </span>
                            <span className="ms-auto">
                                <CloseSharpIcon
                                    style={{ width: '20px' }}
                                    className="pointer"
                                    onClick={() => setAlert(true)} // Dismiss the alert
                                />
                            </span>
                        </div>
                        <div>
                            <span>{t("Newsfeed.Accounce")} </span>


                            <Link to={`/User/${userUid}`} className="border-bottom f-600 warn-resume">
                                {t("Newsfeed.Manage Profile")}
                                {/* Manage Profile */}
                            </Link>
                        </div>
                    </div>
                )}
                {/* {(guestModeData === 'false'|| guestModeData===null) && userPer <= 60 && alert === false && (
                    <div className='p-3 closeAccount m-0 mb-3'>
                        <div className='d-flex mb-3 align-items-center'>
                            <InfoSharpIcon />
                            <span className='cardHeader ms-1'>Announcement!</span>
                            <span className="ms-auto">
                                <CloseSharpIcon style={{ width: '20px' }} className="pointer" onClick={() => {
                                    setAlert(true);
                                }} />
                            </span>
                        </div>
                        <div>
                            <span>{t("Common.ApplyingForNewJob")}</span>

                        </div>
                        <div className=" mt-2">
                    <Link to={`/User/${userUid}`}>
                       <button
                          color=""
                           className="closebtn"
                             style={{ width: "150px" }}  >
                        Manage Profile
                      </button>
                    </Link>
                </div>
                    </div>)} */}
                <div className="advertiseImage">
                    {/* <img src={NewsFeed.Advertise} alt="" /> */}
                    <div className="advertisementview mb-2">
                        <div className="advertisementContainer" style={{
                            width: "100%",
                            height: "180px", // Set a fixed height
                            overflow: "hidden", // Prevent overflow issues
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',

                        }}>
                            <GoogleAdUnit
                                adSlot="9135916775"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    height: "100%",
                                    margin: "0 auto",
                                }}
                            />
                        </div>
                        {/* <h1 className="adText">Advertisement</h1> */}
                    </div>

                </div>
                <div
                    ref={workspaceRef}
                    className={`job-search-workspace${mobileFiltersOpen ? " is-filters-open" : ""}`}
                >
                <div ref={stickyChromeRef} className="job-search-sticky-chrome">
                <div className="job-search-pagehead">
                    <button
                        type="button"
                        className="wlj-job-filters-toggle"
                        aria-expanded={mobileFiltersOpen}
                        aria-controls="job-search-advanced-filters job-search-sidebar-filters"
                        onClick={() => setMobileFiltersOpen((open) => !open)}
                    >
                        <TuneSharpIcon />
                        <span>
                            {mobileFiltersOpen
                                ? t("SearchJob.HideFilters", { defaultValue: "Hide filters" })
                                : t("SearchJob.Filters", { defaultValue: "Filters" })}
                        </span>
                    </button>
                </div>
                <div id="job-search-advanced-filters" className="job-search-advanced-filters">
                <SearchHeader
                    country={country || []}
                    city={city || []}
                    companyList={companyList || []}
                    designationList={designationList || []}
                    selectedCountryData={selectedCountryData || []}
                    setSelectedCountryData={setSelectedCountryData}
                    selectedCity={selectedCity || []}
                    setSelectedCity={setSelectedCity}
                    selectedCompanyData={selectedCompanyData || []}
                    setSelectedCompanyData={setSelectedCompanyData}
                    selectedDesignationData={selectedDesignationData || []}
                    setSelectedDesignationData={setSelectedDesignationData}
                    setReset={setReset}
                    onResetFilters={() => {
                        const masters = filterMastersRef.current;
                        const countryIds = (masters.country || []).map((item) => item.id);
                        const cityIds = (masters.city || []).map((item) => item.id);
                        const companyIds = (masters.company || []).map((item) => item.id);
                        const designationIds = (masters.designation || []).map((item) => item.id);
                        setCountry(masters.country || []);
                        setCity(masters.city || []);
                        setCompanyList(masters.company || []);
                        setDesignationList(masters.designation || []);
                        setSelectedCountryData(countryIds);
                        setSelectedCity(cityIds);
                        setSelectedCompanyData(companyIds);
                        setSelectedDesignationData(designationIds);
                        lastListScopeRef.current = {
                            countryKey: "[]",
                            cityKey: "[]",
                            companyKey: "[]",
                        };
                        setReset(true);
                    }}
                />
                </div>
                </div>
                <div className="row jobMainContainer job-search-main-row">
                    <div id="job-search-sidebar-filters" className="col-lg-3 col-md-4 job-search-sidebar">
                        <div className="job-search-sidebar-inner">
                        <JobFilter
                            setJobsList={setJobsList}
                            jobsList={jobsList}
                            setSelectedJobTypeData={setSelectedJobTypeData || []}
                            jobTypeList={jobTypeList || []}
                            salaryTypeList={salaryTypeList || []}
                            setSelectedSalaryType={setSelectedSalaryType || []}
                            workLevelTypeList={workLevelTypeList || []}
                            setSelectedWorkLevel={setSelectedWorkLevel || []}
                            workLocationType={workLocationType || []}
                            setSelectedWorkLocationList={setSelectedWorkLocationList || []}
                            setReset={setReset}
                        />
                        <div className="advertiseImage job-search-sidebar-ad">
                            <div className="advertisementview">
                                <div className="advertisementContainer" style={{
                                    width: "100%",
                                    height: "200px",
                                    overflow: "hidden",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <GoogleAdUnit
                                        adSlot="9135916775"
                                        style={{
                                            display: "block",
                                            width: "100%",
                                            height: "100%",
                                            margin: "0 auto",
                                        }}
                                    />
                                </div>
                                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-8 job-search-list-column">
                        <JobList
                            refContainer={scrollContainerRef}
                            jobsList={jobsList}
                            setJobsList={setJobsList}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            isLoading={isLoading}
                            isError={isError}
                            page={page}
                            getAllJobList={() => getAllJobList(1, { replaceList: true })}
                            totalPages={totalPages}
                            setTotalPages={setTotalPages}
                            setReset={setReset}
                            filterJobList={filterJobList}
                            reset={reset}
                            nextBatchLoading={nextBatchLoading}
                            hasMoreData={hasMoreData}
                            filterBar={(
                                <div className="wlj-filter-bar">
                                    {[
                                        { id: "all", label: t("SearchJob.AllJobs") },
                                        { id: "complete", label: t("Recruiter.Complete") },
                                        { id: "incomplete", label: t("Recruiter.Incomplete") },
                                        { id: "missingWeights", label: t("Recruiter.NoWeights") },
                                        { id: "weightageGap", label: t("Recruiter.WeightageGap") },
                                        { id: "stale", label: t("Recruiter.Stale") },
                                    ].map((chip) => (
                                        <button
                                            key={chip.id}
                                            type="button"
                                            className={`wlj-filter-chip ${completenessFilter === chip.id ? "is-active" : ""}`}
                                            onClick={() => setCompletenessFilter(chip.id)}
                                        >
                                            {chip.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        />
                    </div>
                    {/* <div className="col-md-2">
                        <div className="jobList py-3 text-center desktopView">
                            <img src={header.ad1} alt="" width={"100%"} />
                        </div>
                    </div> */}
                </div>
                </div>
            </div>
        </>
    )
}

export default JobSearch